<template>
  <div class="app flex-row align-items-center">
    <vue-progress-bar></vue-progress-bar>
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-12">
          <div class="">
            <h1>Register</h1>
          </div>
          <div class="card-group mb-0">
            <loading :active.sync=" isLoading " :is-full-page=" false "></loading>
            <div class="card p-3">
              <div class="card-body">
                <p class="text-muted">Identitas Perusahaan</p>
                <small class="text-danger" v-show=" errors.has( 'No Id Perusahaan' ) ">
                  {{ errors.first( 'No Id Perusahaan' )}}
                </small>
                <div class="input-group mb-3">
                  <span class="input-group-addon">Identitas</span>
                  <select class="form-control" name="kdid" v-model=" form.perkdid ">
                    <option value="5">NPWP</option>
                    <option value="2">KTP</option>
                    <option value="3">Paspor</option>
                    <option value="4">Lainnya</option>
                  </select>
                  <input name="No Id Perusahaan" type="text" class="form-control" v-validate="form.perkdid === '5' ? 'required|min:16' : 'required' "
                    placeholder="No Identitas" v-model=" form.perid ">
                </div>
                <div class="input-group mb-3">
                  <span class="input-group-addon">Upload Identitas</span>
                  <input type="file" class="form-control" @change=" chfileperid ">
                </div>

                <small class="text-danger" v-show=" errors.has( 'Nama Perusahaan' ) ">
                  {{ errors.first( 'Nama Perusahaan' )}}
                </small>
                <div class="input-group mb-3">
                  <span class="input-group-addon"><i class="fa fa-address-card"></i></span>
                  <input name="Nama Perusahaan" v-validate=" 'required' " type="text" class="form-control"
                    placeholder="Nama Perusahaan" v-model=" form.pernama ">
                </div>

                <small class="text-danger" v-show=" errors.has( 'Alamat Perusahaan' ) ">
                  {{ errors.first( 'Alamat Perusahaan' )}}
                </small>
                <div class="input-group mb-3">
                  <span class="input-group-addon"><i class="fa fa-home"></i></span>
                  <input name="Alamat Perusahaan" v-validate=" 'required' " type="text" class="form-control"
                    placeholder="Alamat Perusahaan" v-model=" form.peralamat ">
                </div>

                <small class="text-danger" v-show=" errors.has( 'No Telepon Perusahaan' ) ">
                  {{ errors.first( 'No Telepon Perusahaan' )}}
                </small>
                <div class="input-group mb-3">
                  <span class="input-group-addon"><i class="fa fa-phone"></i></span>
                  <input name="No Telepon Perusahaan" v-validate=" 'required|max:15|min:3' " type="text"
                    class="form-control" placeholder="No Telepon Perusahaan" v-model=" form.pernotelp ">
                </div>

                <small class="text-danger" v-show=" errors.has( 'Email Perusahaan' ) ">
                  {{ errors.first( 'Email Perusahaan' )}}
                </small>
                <div class="input-group mb-3">
                  <span class="input-group-addon">@</span>
                  <input name="Email Perusahaan" v-validate=" 'required|email' " type="text" class="form-control"
                    placeholder="Email Perusahaan" v-model=" form.peremail ">
                </div>

                <div class="input-group mb-3">
                  <span class="input-group-addon">Akses Kepabeanan</span>
                  <select class="form-control" name="" v-model=" form.perakses ">
                    <option value="N" selected="true"></option>
                    <option value="Y">PENGANGKUT</option>
                    <option value="Y">PPJK</option>
                    <option value="N">IMPORTIR</option>
                    <option value="N">EKSPORTIR</option>
                    <option value="N">PERORANGAN</option>
                    <option value="S">PENGUSAHA TPS/KP/BKC/</option>
                    <option value="N">PENGUSAHA JASA TITIPAN</option>
                    <option value="M">PPFTZ Manual</option>
                  </select>
                </div>

                <small class="text-danger" v-show=" errors.has( 'username' ) ">
                  {{ errors.first( 'username' )}}
                </small>
                <div class="input-group mb-3">
                  <span class="input-group-addon"><i class="icon-user"></i></span>
                  <input name="username" v-validate=" 'required' " type="text" class="form-control" placeholder="Username"
                    v-model=" form.username ">
                </div>

                <small class="text-danger" v-show=" errors.has( 'password' ) ">
                  {{ errors.first( 'password' )}}
                </small>
                <div class="input-group mb-3">
                  <span class="input-group-addon"><i class="icon-lock"></i></span>
                  <input name="password" v-validate=" 'required' " type="password" class="form-control"
                    placeholder="Password" v-model=" form.password ">
                </div>
              </div>
            </div>
            <div class="card p-3">
              <div class="card-body">
                <p class="text-muted">Identitas Pendaftar</p>
                <small class="text-danger" v-show=" errors.has( 'No Identitas Pendaftar' ) ">
                  {{ errors.first( 'No Identitas Pendaftar' )}}
                </small>
                <div class="input-group mb-3">
                  <span class="input-group-addon">Identitas</span>
                  <select class="form-control" name="kdid" v-model=" form.dafkdid ">
                    <option value="5">NPWP</option>
                    <option value="2">KTP</option>
                    <option value="3">Paspor</option>
                    <option value="4">Lainnya</option>
                  </select>
                  <input name="No Identitas Pendaftar" v-validate="form.dafkdid === '5' ? 'required|min:16' : 'required' " type="text" class="form-control"
                    placeholder="No Identitas Pendaftar" v-model=" form.dafid ">
                </div>
                <div class="input-group mb-3">
                  <span class="input-group-addon">Upload Identitas</span>
                  <input type="file" class="form-control" @change=" chfiledafid ">
                </div>

                <small class="text-danger" v-show=" errors.has( 'Nama Pendaftar' ) ">
                  {{ errors.first( 'Nama Pendaftar' )}}
                </small>
                <div class="input-group mb-3">
                  <span class="input-group-addon"><i class="fa fa-address-card"></i></span>
                  <input name="Nama Pendaftar" v-validate=" 'required' " type="text" class="form-control"
                    placeholder="Nama Pendaftar" v-model=" form.dafnama ">
                </div>

                <small class="text-danger" v-show=" errors.has( 'Alamat Pendaftar' ) ">
                  {{ errors.first( 'Alamat Pendaftar' )}}
                </small>
                <div class="input-group mb-3">
                  <span class="input-group-addon"><i class="fa fa-home"></i></span>
                  <input name="Alamat Pendaftar" v-validate=" 'required' " type="text" class="form-control"
                    placeholder="Alamat Pendaftar" v-model=" form.dafalamat ">
                </div>

                <small class="text-danger" v-show=" errors.has( 'No Telepon Pendaftar' ) ">
                  {{ errors.first( 'No Telepon Pendaftar' )}}
                </small>
                <div class="input-group mb-3">
                  <span class="input-group-addon"><i class="fa fa-phone"></i></span>
                  <input name="No Telepon Pendaftar" v-validate=" 'required|max:15|min:3' " type="text"
                    class="form-control" placeholder="No Telepon Pendaftar (Contoh: 081234567890)" v-model=" form.dafnotelp ">
                </div>

                <small class="text-danger" v-show=" errors.has( 'Email Pendaftar' ) ">
                  {{ errors.first( 'Email Pendaftar' )}}
                </small>
                <div class="input-group mb-3">
                  <span class="input-group-addon">@</span>
                  <input name="Email Pendaftar" v-validate=" 'required|email' " type="text" class="form-control"
                    placeholder="Email Pendaftar" v-model=" form.dafemail ">
                </div>
                <small class="text-danger" v-show=" errors.has( 'File Surat Pernyataan' ) ">
                  {{ errors.first( 'File Surat Pernyataan' )}}
                </small>
                <div class="input-group mb-3">
                  <span class="input-group-addon">Surat Pernyataan</span>
                  <input type="file" class="form-control" v-validate=" 'required' " name="File Surat Pernyataan"
                    @change=" chsuratpernyataan ">
                </div>

                <div class="input-group mb-3">
                  <span class="input-group-addon">Surat Kuasa</span>
                  <input type="file" name="File Surat Kuasa" class="form-control" @change=" chsuratkuasa ">
                </div>

                <div class="pull-right">


                </div>
                <div class="input-group mb-3">
                  <div class="input-group mb-3">
                    <!-- <div class="g-recaptcha" data-sitekey="your_site_key"></div> -->
                    <vue-recaptcha
                      :sitekey=sitekey
                      @verify="onCaptchaVerified"
                      @expired="onCaptchaExpired"
                    ></vue-recaptcha>
                  </div>
                </div>
                <div class="card-footer p-3">
                  <div class="row">
                    <div class="col-6">
                      <button type="button" class="btn btn-block btn-primary" @click=" sendregis "><i
                          class="fa fa-save"></i> Create Account</button>
                    </div>
                    <div class="col-6">
                      <router-link :to=" '/login' " class="btn btn-block btn-danger"><i class="fa fa-remove"></i> Cancel
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueRecaptcha from 'vue-recaptcha'
import swal from 'sweetalert'
import Loading from 'vue-loading-overlay'
export default {
  components: {Loading, VueRecaptcha},
  data () {
    return {
      form: {
        perkdid: '5',
        perid: '',
        pernama: '',
        peralamat: '',
        pernotelp: '',
        peremail: '',
        perakses: 'N',
        dafkdid: '5',
        dafid: '',
        dafnama: '',
        dafalamat: '',
        dafnotelp: '',
        dafemail: '',
        daffileid: '',
        username: '',
        password: '',
        fileperid: '',
        filedafid: '',
        exfileperid: '',
        exfiledafid: '',
        filesrtkuasa: '',
        exfilesrtkuasa: '',
        filesrtpernyataan: '',
        exfilesrtpernyataan: '',
        recaptchaToken: ''
      },
      isLoading: false,
      sitekey: '6LfnWwIqAAAAANCiVDEj6w0E6IzsYRw7_6Kg3IZd'
    }
  },
  methods: {
    chfileperid (e) {
      this.$Progress.start()
      var fileReader = new FileReader()
      this.form.exfileperid = e.target.files[0].name.substr((e.target.files[0].name.lastIndexOf('.') + 1))
      fileReader.readAsDataURL(e.target.files[0])
      fileReader.onload = (e) => {
        this.form.fileperid = e.target.result
      }
      this.$Progress.finish()
    },
    chfiledafid (e) {
      this.$Progress.start()
      var fileReader = new FileReader()
      this.form.exfiledafid = e.target.files[0].name.substr((e.target.files[0].name.lastIndexOf('.') + 1))
      fileReader.readAsDataURL(e.target.files[0])
      fileReader.onload = (e) => {
        this.form.filedafid = e.target.result
      }
      this.$Progress.finish()
    },
    chsuratkuasa (e) {
      this.$Progress.start()
      var fileReader = new FileReader()
      this.form.exfilesrtkuasa = e.target.files[0].name.substr((e.target.files[0].name.lastIndexOf('.') + 1))
      fileReader.readAsDataURL(e.target.files[0])
      fileReader.onload = (e) => {
        this.form.filesrtkuasa = e.target.result
      }
      this.$Progress.finish()
    },
    chsuratpernyataan (e) {
      this.$Progress.start()
      var fileReader = new FileReader()
      this.form.exfilesrtpernyataan = e.target.files[0].name.substr((e.target.files[0].name.lastIndexOf('.') + 1))
      fileReader.readAsDataURL(e.target.files[0])
      fileReader.onload = (e) => {
        this.form.filesrtpernyataan = e.target.result
      }
      this.$Progress.finish()
    },
    sendmail () {
      var mail = {
        page: 'register',
        subject: 'Registrasi User',
        data: this.form.pernama,
        email: this.form.peremail,
        nama: this.form.pernama,
        peralamat: this.form.peralamat,
        peremail: this.form.peremail,
        dafnama: this.form.dafnama,
        dafalamat: this.form.dafalamat,
        dafnotelp: this.form.dafnotelp,
        dafemail: this.form.dafemail,
        username: this.form.username,
        password: this.form.password,
        npwp: this.form.perid
      }
      this.$http.post('bc/mail/kir-fidut-telstb1', mail)
    },
    onCaptchaVerified (recaptchaToken) {
      this.form.recaptchaToken = recaptchaToken
    },
    onCaptchaExpired () {
      this.form.recaptchaToken = ''
    },
    sendregis () {
      this.$validator.validateAll().then((result) => {
        if (result && this.form.recaptchaToken) {
          this.$Progress.start()
          this.isLoading = true
          this.$http.post('reg-madurm171', this.form)
            .then(response => {
              swal(response.data.status, response.data.message, response.data.status)
              if (response.data.status === 'success') {
                this.sendmail()
                this.isLoading = false
                this.$router.push('/login')
              }
              this.$Progress.finish()
            }).catch((error) => {
              this.isLoading = false
              swal(error.data.status, error.data.message, error.data.status)
            })
        } else {
          swal('error', 'Mohon Isi dengan Lengkap', 'error')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Register.vue?50db9d04